import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import InputLabel from '@mui/material/InputLabel';
import OutlinedInput from '@mui/material/OutlinedInput';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import FilterIcon from '@mui/icons-material/Filter';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import { object } from 'prop-types';
import { Grid } from '@mui/material';



function FilterBy({ list, setList, setFlag }) {

    const [open, setOpen] = React.useState(false); 

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
     
        setOpen(false);
    };   

    return (
        <div style={{paddingBottom:"10px"}}>
            <div>
                
                <Button onClick={handleClickOpen} variant="contained" style={{ backgroundColor: "#ffffff", color: "#4f4f4f", marginTop: "10px", zIndex:"1", textTransform: 'none' }} startIcon={<AssignmentTurnedInIcon />}>
                    Filter
                </Button>
            </div> 
            <Dialog disableEscapeKeyDown open={open} onClose={handleClose} maxWidth={"sm"} fullWidth={true} style={{ margin: "15px" }}>
                <DialogTitle>Filter by:</DialogTitle> 
                <Grid style={{ display: "flex", flexDirection: "row", flexWrap: "wrap", justifyContent: "center", paddingBottom: "30px" }}>
                    {Object.keys(list).map((name, index) => (
                        <Button key={index}
                            onClick={() => {
                                setList({ ...list, [name]: !list[name] });
                                setFlag(true);
                            }}
                            variant={list[name] ? "contained" : "text"} size="small"
                            style={{ marginLeft: "5px", marginRight: "5px", marginBottom: "5px", marginTop: "5px", backgroundColor: list[name] ? "#00497E" : "#ffffff", color: list[name] ? "#ffffff" : "#4f4f4f", minWidth: "80px", maxWidth:"150px" }}
                        >
                            {name}
                        </Button>
                    ))} 
                </Grid>
            </Dialog>
        </div>
    );
}

export { FilterBy }